import type { CuttingDocument } from '../model/types';
// Type-only импорт — стирается при компиляции (НЕ тянет SheetJS в main-бандл).
// Рантайм-загрузка только через динамический import() ниже (ADR-0096, code-splitting).
import type * as XLSXNamespace from 'xlsx';
import { PARTS_HEADER, buildPartsRows } from './partsCsv';

type XLSXModule = typeof XLSXNamespace;

/**
 * Block 14 «Раскрой» — экспорт списка деталей в Excel `.xlsx` (ADR-0096, SheetJS).
 * Лист строится из ТОГО ЖЕ 16-колоночного маппинга, что и `buildPartsCsv` (TRD
 * §7.6) — общие `PARTS_HEADER` + `buildPartsRows`, чтобы CSV и XLSX не разъехались.
 * Всё клиентское (P-009): книга формируется в браузере, на сервер не уходит.
 */

/** Заголовок + строки для листа (общий 16-колоночный маппинг). */
export function buildPartsAoa(doc: CuttingDocument): string[][] {
  return [[...PARTS_HEADER], ...buildPartsRows(doc)];
}

/** .xlsx-Blob из списка деталей. SheetJS грузится лениво (не в main-бандл). */
export async function buildPartsXlsxBlob(doc: CuttingDocument): Promise<Blob> {
  const mod = await import('xlsx');
  // CJS-интероп: namespace может оказаться под .default (Vite). Берём защитно.
  const wrapped = mod as XLSXModule & { default?: XLSXModule };
  const XLSX: XLSXModule = wrapped.utils ? wrapped : (wrapped.default as XLSXModule);
  const ws = XLSX.utils.aoa_to_sheet(buildPartsAoa(doc));
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Детали');
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' }) as ArrayBuffer;
  return new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
}
